import InViewController from 'scripts/marmalade/classes/in-view';
const InView = new InViewController({
  rootMargin: '0px 0px -2% 0px'
});

// When these elements enter the page, add the class 'in-view'
InView.on('enter', element => {
  // If this element already has the class 'in-view', return
  if (element.classList.contains('in-view')) return;
  // Add the class 'in-view'
  setTimeout(() => element.classList.add('in-view'));
});

// Watch for all element on the page with the class .js-in-view
InView.watch('.js-in-view');